module.exports = __webpack_public_path__ + "img/lobby_x_case_navigation.5b3e5563.gif";